import type { Dispatch } from 'redux'

import { SET_CHECKOUT_NOTIFICATION, RESET_CHECKOUT_NOTIFICATION } from '../constants/ActionTypes'

type CheckoutNotificationOptions = {
    autoHideDelay?: number
    sticky?: boolean | null
}

const setCheckoutNotificationActionCreator = (type: string, message: string, sticky: boolean | null = null) => ({
    type: SET_CHECKOUT_NOTIFICATION,
    notification: { type, message, sticky },
})

const resetCheckoutNotificationAction = {
    type: RESET_CHECKOUT_NOTIFICATION,
}

let checkoutNotificationTimeout: undefined | ReturnType<typeof setTimeout> = undefined

export const clearCheckoutNotificationTimeout = () => {
    if (checkoutNotificationTimeout) {
        clearTimeout(checkoutNotificationTimeout)
        checkoutNotificationTimeout = undefined
    }
}

export const setCheckoutNotification = (type: string, message: string, { autoHideDelay = 0, sticky = false }: CheckoutNotificationOptions = {}) => {
    return (dispatch: Dispatch) => {
        clearCheckoutNotificationTimeout()
        dispatch(setCheckoutNotificationActionCreator(type, message, sticky))
        if (autoHideDelay > 0) {
            checkoutNotificationTimeout = setTimeout(() => dispatch(resetCheckoutNotificationAction), autoHideDelay)
        }
    }
}

export const resetCheckoutNotification = () => {
    return (dispatch: Dispatch) => {
        clearCheckoutNotificationTimeout()
        dispatch(resetCheckoutNotificationAction)
    }
}
